var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('heading-image-section',{staticClass:"heading-image-section-module",attrs:{"desktop-image":_vm.desktopImage,"mobile-image":_vm.mobileImage,"title":_vm.attributes.heading_image_title}})}
var staticRenderFns = []

export { render, staticRenderFns }